import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number2CircleFilled"
const Number2CircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M11.99 6.35C10.445 6.35 9.125 7.34 8.675 8.78L10.535 9.335C10.745 8.63 11.255 8.15 11.96 8.15 12.755 8.15 13.325 8.825 13.325 9.56 13.325 10.1 13.1 10.7 12.29 11.615L8.6 15.8V17H15.425V15.2H11.765L14 12.605C14.705 11.795 15.35 10.865 15.35 9.59 15.35 7.7 13.79 6.35 11.99 6.35"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default Number2CircleFilledIcon
